import React, { useEffect, useState } from 'react';
import { Button } from '../../components/form/button';
import { Card } from '../../components/card/card';
import { useTaxApiV1 } from '../../clients/quipli-service/tax/tax-api-v1';
import { TaxCategory } from '../../clients/quipli-service/tax/tax';
import { TaxCategoryModal } from './tax-category-modal';
import Icon from '../../components/icons/icon';

export const TaxCategorySetup = () => {
  const [setupModalOpen, setSetupModalOpen] = useState<boolean>(false);
  const { searchTaxCategories } = useTaxApiV1();
  const [taxCategories, setTaxCategories] = useState<TaxCategory[]>([]);
  const [taxCategoryToEdit, setTaxCategoryToEdit] = useState<TaxCategory | undefined>();
  async function init() {
    const categories = await searchTaxCategories({});
    setTaxCategories(categories);
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <div className="tax-category-setup">
      <div className={'tax-category-table py-2 pt-8 pb-8'}>
        <Card>
          <table className="w-full border-none">
            <thead>
              <tr>
                <th className={'text-left'}>
                  <span>Category Name</span>
                </th>
                <th className={'text-left'}>
                  <span>Description</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {taxCategories.map((category) => {
                return (
                  <React.Fragment key={category.id}>
                    <tr>
                      <td className={'text-left flex group gap-2 items-center mt-2.5'}>
                        <span>{category.name}</span>
                        <div className="flex gap-2 taxcode-actions hidden group-hover:block self-start max-h-full">
                          <Button
                            className="button-tertiary taxcode-button max-h-fit"
                            onClick={() => {
                              setTaxCategoryToEdit(category);
                              setSetupModalOpen(true);
                            }}
                          >
                            <Icon icon={'Edit'} stroke="var(--grey-400)" />
                          </Button>
                        </div>
                      </td>
                      <td className={'text-left'}>{category.description}</td>
                    </tr>
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </Card>
      </div>
      <Button className="button-yellow" onClick={() => setSetupModalOpen(true)}>
        Create a tax category
      </Button>
      <TaxCategoryModal
        isOpen={setupModalOpen}
        close={() => {
          setSetupModalOpen(false);
          setTaxCategoryToEdit(undefined);
          init();
        }}
        existing={taxCategoryToEdit}
      />
    </div>
  );
};
